import React from 'react'

import './style.css'

function Footer() {
    return (
        <div>
            <div className="footer">
              Website made by Renato Cesar <br/>Contact: re.fbarcellos@hotmail.com
            </div>
        </div>
    )
}

export default Footer;